import { useMutation } from 'react-query';
import { useTranslation } from 'react-i18next';

import { useApiContext } from 'context/ApiContext';
import { useGlobalContext } from 'context/GlobalContext';

const useUpdateAccountLanguage = () => {
  const { security: securityApi } = useApiContext();
  const { showApiError, showSuccess } = useGlobalContext();
  const { t } = useTranslation('global');

  return useMutation(
    (data: { langId: number; id: number }) =>
      securityApi.accounts.UpdateAccountLanguage(data),
    {
      onError: (error) => {
        showApiError(error, t('errorMessages.changeLanguage'), 3000);
      },
      onSuccess: () => {
        showSuccess(t('general.languageUpdated'), 3000);
      }
    }
  );
};

export default useUpdateAccountLanguage;
